import React from 'react';
import { useTranslation } from "react-i18next";
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ActiveTab, TabContainer } from "../types"
const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: (props: any) => props.direction,
      marginRight: "2.1875rem",
      "& div": {
        paddingBottom: "0.3125rem",
        "& header": {
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontSize: "1.0625rem",
          lineHeight: " 1.4375rem",
          display: "flex",
          alignItems: "center",
          color: "#8D98B7",
          padding: "0.9375rem 1.875rem",
          width: "14.6875rem",
          cursor: "pointer"
        },
        "& ul": {
          margin: 0,
          padding: 0,
          "& li": {
            fontFamily: "Open Sans",
            fontStyle: "normal",
            fontSize: "1rem",
            lineHeight: " 1.375rem",
            display: "flex",
            alignItems: "center",
            color: "#8D98B7",
            listStyle: "none",
            padding: "0.625rem 2.1875rem",
            maxWidth: "14.6875rem",
            width: "14.6875rem",
            cursor: "pointer"
          }
        },
      },
    },
    selected: {
      background: "#FFFFFF",
      borderRadius: "8px",
      color: "#212121!important",
      fontWeight: 600,
      position: "relative",
      "& span": {
        position: "absolute",
        background: "#FFDD02",
        borderRadius: "12px",
        width: "4px",
        height: "12px",
        left: "0.9375rem",
        transform: "matrix(-1, 0, 0, 1, 0, 0)"
      }
    },
    items: {},
    activeClass: {
      fontSize: "1.0625rem!important",
      lineHeight: " 1.4375rem!important",
      color: "#212121!important"
    },
    "@media (max-width: 1000px)": {
      root: {
        flexDirection: "row!important",
        marginBottom: "2rem",
        position: "relative",
        "& div": {
          "& header": {
            justifyContent: "center!important",
            width: "fit-content!important",
            textAlign: "center"
          }
        },
        "& ul": {
          display: "flex",
          position: "absolute",
          left: "0",
          width: "100%",
          "& li": {
            justifyContent: "center!important",
            width: "fit-content!important"
          }
        }
      },
    },
    "@media (max-width: 768px)": {
      root: {
        "& div": {
          "& header": {
            padding: "0.9375rem .5rem!important",
          }
        },
        "& ul": {
          "& li": {
            padding: "0.625rem 1.1875rem!important",
          }
        },

      },
      selected: {
        "& span": {
          display: "none!important",
        }
      }
    },
  }),
);

interface ITabs {
  direction: string;
  tabs: TabContainer[];
  onChange: (tab: TabContainer) => void;
  activeTab: ActiveTab;
}

export function Tabs(props: ITabs) {
  const classes = useStyles(props);
  const { t } = useTranslation();
  const { activeTab, onChange, tabs } = props;
  function handleTabClick(tab: TabContainer) {
    onChange(tab);
  }

  return (
    <div className={classes.root} >
      {tabs.map((tab: TabContainer) => <div>
        {tab.title && <header
          className={activeTab.key === tab.key ? classes.selected : undefined}
          onClick={() => handleTabClick(tab)}>
          <span></span>
          <>{t(tab.title)}</>
        </header>}
      </div>
      )}
    </div>
  )
}
